import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled, { css } from "styled-components";

type LabeledValueVariant = "large" | "small";

type LabeledValueProps = {
  label: string;
  muted?: boolean;
  truncate?: boolean;
  value: string;
  variant?: LabeledValueVariant;
};

export const LabeledValue = ({
  label,
  muted,
  truncate,
  value,
  variant = "large",
}: LabeledValueProps): JSX.Element => {
  return (
    <Cell $variant={variant}>
      <Value $muted={muted} $truncate={truncate} $variant={variant}>
        {value}
      </Value>
      <Label>{label}</Label>
    </Cell>
  );
};

const Cell = styled.div<{ $variant: LabeledValueVariant }>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => (props.$variant === "large" ? "6px" : "4px")};
  min-width: 0;
`;

const truncateStyles = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Value = styled.span<{
  $muted?: boolean;
  $truncate?: boolean;
  $variant: LabeledValueVariant;
}>`
  ${(props) =>
    props.$variant === "large" ? TypographyV2.h5 : TypographyV2.b2};
  color: ${(props) => (props.$muted ? ColorV2.Blue5 : ColorV2.Blue1)};
  ${(props) => props.$variant === "large" && "line-height: 1;"}
  ${(props) => props.$truncate && truncateStyles}
`;

const Label = styled.span`
  ${TypographyV2.s1};
  color: ${ColorV2.Blue4};
`;
